namespace $.$$ {

	export type $shm_hitalama_agent_api_session = $shm_opencode_api_session
	export type $shm_hitalama_agent_api_config = $shm_opencode_api_config
	export type $shm_hitalama_agent_api_provider = $shm_opencode_api_provider
	export type $shm_hitalama_agent_api_tokens = $shm_opencode_api_tokens
	export type $shm_hitalama_agent_api_message = $shm_opencode_api_message
	export type $shm_hitalama_agent_api_question = $shm_opencode_api_question
	export type $shm_hitalama_agent_api_event = $shm_opencode_api_event

	// OpenCode and DSH share this protocol; keep its implementation in one place.
	export const $shm_hitalama_agent_api = $shm_opencode_api
	export const $shm_hitalama_agent_api_error = $shm_opencode_api_error
	export class $shm_hitalama_agent_api_events extends $shm_opencode_api_events {}

}
